export const backstageSynthTheme = {
    id: 'backstage-synth',
    label: 'Backstage Synth',
    description: 'Flagship dark + neon. Strong stage-lighting identity.',
    paletteMode: 'dark',
    tokens: {
        app: { bg: '#0B0F14', bgElevated: '#111820' },
        surface: {
            nav: '#0B0F14',
            panel: '#1A232D',
            panelAlt: '#2F4858',
            input: '#111820',
        },
        border: {
            default: 'rgba(214, 222, 232, 0.14)',
            strong: 'rgba(0, 217, 255, 0.48)',
        },
        text: {
            primary: '#D6DEE8',
            secondary: '#98A7B6',
            disabled: '#667482',
            inverse: '#061016',
        },
        action: {
            primary: '#00D9FF',
            primaryHover: '#5BEAFF',
            secondary: '#FF2E88',
        },
        state: {
            success: '#41FF8A',
            warning: '#FFB000',
            error: '#FF4F64',
            info: '#00D9FF',
        },
        data: {
            seriesA: '#00D9FF',
            seriesB: '#FF2E88',
            seriesC: '#FFB000',
            seriesD: '#41FF8A',
        },
        effect: {
            glow: 'rgba(0, 217, 255, 0.42)',
            shadow: '0 18px 60px rgba(0, 0, 0, 0.36)',
        },
    },
};
//# sourceMappingURL=backstage-synth.js.map